import { connect } from 'react-redux'
import Reports from './Reports'
import { getDataSource } from '../../store/appReducer'
import { DATASOURCES } from '../../constants'
import {
  getReportsData,
  getReportIdsFromDataSource,
  handleOnSortClick,
  handleOnFilterButtonClick,
  handleOnFilterChange,
  updateSelectedReports,
  handleOnBulkAction,
  handleOnRowClick,
  handleOnRefreshClick,
  handleOnSelectionClick,
} from './module'

const mapActionCreators = {
  getReportsData,
  handleOnSortClick,
  handleOnFilterButtonClick,
  handleOnFilterChange,
  updateSelectedReports,
  handleOnBulkAction,
  handleOnRowClick,
  handleOnRefreshClick,
  handleOnSelectionClick,
}

const mapStateToProps = state => ({
  dataIsFetching: state.reports.dataIsFetching,
  dataLastUpdated: state.reports.dataLastUpdated,
  refreshClicked: state.reports.refreshClicked,
  bulkActionComplete: state.reports.bulkActionComplete,
  bulkActionIsFetching: state.reports.bulkActionIsFetching,
  bulkActionSuccessMessage: state.reports.bulkActionSuccessMessage,
  selectedPopover: state.reports.selectedPopover,
  selectedIndex: state.reports.selectedIndex,

  selectedStartDate: state.reports.selectedStartDate,
  selectedEndDate: state.reports.selectedEndDate,
  selectedPatientId: state.reports.selectedPatientId,
  selectedPhysicianId: state.reports.selectedPhysicianId,
  selectedPhysicians: state.reports.selectedPhysicians,
  selectedPrescriptionId: state.reports.selectedPrescriptionId,
  selectedBillingCode: state.reports.selectedBillingCode,
  selectedEsignedId: state.reports.selectedEsignedId,
  selectedExportedId: state.reports.selectedExportedId,
  sortBy: state.reports.sortBy,
  sortDirection: state.reports.sortDirection,
  selectedReports: state.reports.selectedReports,

  reportIds: getReportIdsFromDataSource(state),
  me: getDataSource(state, DATASOURCES.ME),
  reports: getDataSource(state, DATASOURCES.REPORTS),
  patients: getDataSource(state, DATASOURCES.PATIENTS),
  prescriptions: getDataSource(state, DATASOURCES.PRESCRIPTIONS),
  physicians: getDataSource(state, DATASOURCES.PHYSICIANS),
  billingCodes: getDataSource(state, DATASOURCES.BILLING_CODES),
})

export default connect(
  mapStateToProps,
  mapActionCreators
)(Reports)



// WEBPACK FOOTER //
// ./src/legacy/pages/Reports/container.js